const EGDSExpandoTriggerStateMap = [['expand', 'opened'], ['collapse', 'closed']];
const EGDSExpandoTriggerStates = new Map(EGDSExpandoTriggerStateMap);
export { EGDSExpandoTriggerStates };